import React from 'react';
import { SkeletonBlock } from '../../components/loading/skeletons';
import './ManagementFilterSkeleton.css';

const FilterSection = ({ label, children }) => (
  <div className="managementFilterSection">
    <p className="managementFilterSectionLabel">{label}</p>
    {children}
  </div>
);

const Stack = ({ children }) => (
  <div className="management-filter-skeleton__stack">{children}</div>
);

const ManagementFilterSkeleton = ({ variant = 'employee', label = 'Loading filters' }) => {
  const isClient = variant === 'client';

  return (
    <div className="management-filter-skeleton" role="status" aria-busy="true" aria-label={label}>
      <div className="clientSearchHeaderToolbar">
        {isClient ? (
          <FilterSection label="Status">
            <div className="management-filter-skeleton__row">
              <SkeletonBlock height={32} />
              <SkeletonBlock height={32} />
            </div>
          </FilterSection>
        ) : null}

        <FilterSection label="Search">
          <SkeletonBlock width="100%" height={38} />
        </FilterSection>

        <FilterSection label="View">
          <Stack>
            <SkeletonBlock width="100%" height={36} />
            <SkeletonBlock width="100%" height={36} />
          </Stack>
        </FilterSection>
      </div>

      {isClient ? null : (
        <FilterSection label="Role">
          <Stack>
            <SkeletonBlock width="100%" height={34} />
            <SkeletonBlock width="100%" height={34} />
            <SkeletonBlock width="100%" height={34} />
            <SkeletonBlock width="100%" height={34} />
          </Stack>
        </FilterSection>
      )}

      <FilterSection label="Actions">
        <Stack>
          <SkeletonBlock width="100%" height={36} />
          <SkeletonBlock width="100%" height={36} />
          <SkeletonBlock width="100%" height={36} />
          <SkeletonBlock width="100%" height={36} />
          {isClient ? null : <SkeletonBlock width="100%" height={36} />}
        </Stack>
      </FilterSection>
    </div>
  );
};

export default ManagementFilterSkeleton;
